<div class="ei-search__container">
    @if (label) {
        <label class="ei-search__label">{{ label }}</label>
    }

    <div class="ei-search__field" [class.is-disabled]="disabled" (click)="focus()">
        <div class="ei-search__content">
            @if (showIcon) {
                <img class="ei-search__icon" [src]="iconSrc" alt="" aria-hidden="true" />
            }

            <input
                #inputEl
                class="ei-search__input"
                type="search"
                [value]="value"
                [placeholder]="placeholder"
                [disabled]="disabled"
                (input)="onInput(inputEl.value)"
                (blur)="onBlur()"
                (keydown)="onKeydown($event)"
            />
        </div>
    </div>

    @if (helperText) {
        <div class="ei-search__helper">{{ helperText }}</div>
    }
</div>
